const storedUser = localStorage.getItem("user");

export const user = JSON.parse(storedUser);

// Store for permission debug mode
let permissionDebugMode = false;
let lastPermissionCheck = null;

export const setPermissionDebugMode = (enabled) => {
  permissionDebugMode = enabled;
};

export const getLastPermissionCheck = () => lastPermissionCheck;

export const HAS_PERMISSION = (moduleId) => {
  try {
    const currentUserStr = localStorage.getItem("user");
    const currentUser = currentUserStr ? JSON.parse(currentUserStr) : null;

    const hasPermission = currentUser?.permissions?.includes(moduleId);

    // Find permission details if in debug mode
    if (permissionDebugMode) {
      const permissionDetails = user?.full_permissions?.find(
        (p) => p.id === moduleId
      );
      lastPermissionCheck = {
        id: moduleId,
        hasPermission,
        name: permissionDetails?.name || "Unknown",
        displayName: permissionDetails?.en_display_name || "Unknown Permission",
      };
    }
    return hasPermission;
  } catch {
    return false;
  }
};

export const HAS_ANY_PERMISSION = (...permissionIds) =>
  permissionIds.some((id) => HAS_PERMISSION(id));

/** Sidebar link: `public` (always visible), single `id`, or OR-group via `ids`. */
export const hasAsideLinkPermission = (link) => {
  if (!link) return false;
  if (link.public) return true;
  if (Array.isArray(link.ids) && link.ids.length) {
    return link.ids.some((id) => HAS_PERMISSION(id));
  }
  if (link.id) return HAS_PERMISSION(link.id);
  return false;
};

/** First granted permission id (or first in group) for debug tooltips. */
export const getAsideLinkPermissionId = (link) => {
  if (!link) return undefined;
  if (Array.isArray(link.ids) && link.ids.length) {
    return link.ids.find((id) => HAS_PERMISSION(id)) ?? link.ids[0];
  }
  return link.id;
};

// Get permission details by ID
export const getPermissionDetails = (moduleId) => {
  const permissionDetails = user?.full_permissions?.find(
    (p) => p.id === moduleId
  );
  return {
    id: moduleId,
    hasPermission: user?.permissions?.includes(moduleId),
    name: permissionDetails?.name || "Unknown",
    displayName: permissionDetails?.en_display_name || "Unknown Permission",
  };
};
